
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","data-name":"Слой 1","viewBox":"0 0 128 128"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M120 56a8 8 0 00-7.74 6H102a37.86 37.86 0 00-9.72-23.4l7.31-7.31a8 8 0 10-2.83-2.83l-7.36 7.31A37.86 37.86 0 0066 26.05V15.74a8 8 0 10-4 0v10.31a37.86 37.86 0 00-23.4 9.72l-7.31-7.31a8 8 0 10-2.83 2.83l7.31 7.31A37.86 37.86 0 0026.05 62H15.74a8 8 0 100 4h10.31a37.86 37.86 0 009.72 23.4l-7.31 7.31a8 8 0 102.83 2.83l7.31-7.31A37.86 37.86 0 0062 102v10.31a8 8 0 104 0V102a37.86 37.86 0 0023.4-9.72l7.31 7.31a8 8 0 102.83-2.83l-7.31-7.36A37.86 37.86 0 00102 66h10.31A8 8 0 10120 56zm-19.23-34.43a4 4 0 11-1.17 2.83 4 4 0 011.17-2.83zM60 8a4 4 0 114 4 4 4 0 01-4-4zM21.57 27.23a4 4 0 015.66-5.66 4 4 0 01-5.66 5.66zM8 68a4 4 0 114-4 4 4 0 01-4 4zm19.23 38.43a4 4 0 01-5.66-5.66 4 4 0 015.66 5.66zM68 120a4 4 0 11-4-4 4 4 0 014 4zm38.43-19.23a4 4 0 01-5.66 5.66 4 4 0 015.66-5.66zM64 98a34 34 0 1134-34 34 34 0 01-34 34zm56-30a4 4 0 114-4 4 4 0 01-4 4z"}}),_c('path',{attrs:{"d":"M40.34 58.34a8 8 0 1011.32 0 8 8 0 00-11.32 0zm8.49 8.49a4 4 0 110-5.66 4 4 0 010 5.66zm9.51-26.49a8 8 0 1011.32 0 8 8 0 00-11.32 0zm8.49 8.49a4 4 0 110-5.66 4 4 0 010 5.66zm9.51 9.51a8 8 0 1011.32 0 8 8 0 00-11.32 0zm8.49 8.49a4 4 0 110-5.66 4 4 0 010 5.66zm-26.49 9.51a8 8 0 1011.32 0 8 8 0 00-11.32 0zm8.49 8.49a4 4 0 110-5.66 4 4 0 010 5.66z"}})])
          )
        }
      }
    